import http from '~/http/new';

export default ({
  state: {
    data: {},
    personalDataRecord: {},
    usePaymentMethodSettingsAsCommissionSource: false,
  },

  getters: {},

  mutations: {
    SET_DATA(state, data) {
      state.data = data;
    },
    SET_PERSONAL_DATA(state, payload) {
      const name = state.usePaymentMethodSettingsAsCommissionSource ? 'paymentMethods' : 'currencies';
      state.personalDataRecord = {
        ...state.personalDataRecord,
        settings: payload.data,
        [name]: payload[name],
      };
    },
    SET_COMMISSION_SOURCE(state, payload) {
      state.usePaymentMethodSettingsAsCommissionSource = payload;
    },
  },

  actions: {
    async loadData({ commit }) {
      const response = await http.get('v1/p2p/fee');
      const { result, ...data } = response.data;
      if (result?.Success) {
        commit('SET_DATA', data);
      }
    },

    async editFees(__store, data) {
      const response = await http.put('v1/p2p/fee', data);
      if (!response?.data?.result?.Success) {
        throw new Error(`The fees has not been edited because of Error: "${response?.data?.result?.Error}"`);
      }
      return response.data;
    },

    async loadPersonalFeeDataById({ commit, state, dispatch }, { userId }) {
      await dispatch('getFeatureFlags');
      const url = state.usePaymentMethodSettingsAsCommissionSource ? 'v1/p2p/profile/payment-method-settings' : 'v1/p2p/fee/profile';

      const response = await http.get(url, { params: { userId } });

      const {
        profiles,
        settings,
        availablePaymentMethods,
        currencyIdsAvailableForFees,
      } = response.data;

      const parameterName = state.usePaymentMethodSettingsAsCommissionSource ? 'paymentMethods' : 'currencies';
      const availableItemsName = state.usePaymentMethodSettingsAsCommissionSource ? availablePaymentMethods : currencyIdsAvailableForFees;

      commit('SET_PERSONAL_DATA', {
        userId,
        data: settings ?? profiles?.[0]?.settings ?? [],
        [parameterName]: availableItemsName,
      });

      return response.data;
    },

    async editPersonalFees({ state }, data) {
      const url = state.usePaymentMethodSettingsAsCommissionSource ? 'v1/p2p/profile/payment-method-settings' : 'v1/p2p/fee/profile';
      const response = await http.put(url, data);
      if (!response?.data?.result?.Success) {
        throw new Error(`Personal fees has not been edited because of Error: "${response?.data?.result?.Error}"`);
      }
      return response.data;
    },

    async getFeatureFlags({ commit }) {
      const response = await http.get('v1/p2p/feature-flags');
      commit('SET_COMMISSION_SOURCE', response.data.usePaymentMethodSettingsAsCommissionSource);
    },
  },

  namespaced: true,
});
